<template>
  <header class="top-nav">
    <div class="top-nav-inner">
      <div class="nav-brand">
        <div class="nav-logo">P</div>
        <span class="nav-name">{{ appName }}</span>
        <span class="nav-separator">|</span>
        <div class="nav-context">
          <span>Connecting to</span>
          <span class="nav-context-strong">{{ platformLabel }}</span>
          <template v-if="storeName">
            <span class="nav-separator">·</span>
            <span>Shop Name</span>
            <span class="nav-store" :title="storeName">{{ storeName }}</span>
          </template>
        </div>
      </div>
      <div class="nav-secure">
        <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
          <path d="M8 1a3.5 3.5 0 0 0-3.5 3.5V6H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.5V4.5A3.5 3.5 0 0 0 8 1zm-2 3.5a2 2 0 1 1 4 0V6H6V4.5z"/>
        </svg>
        <span>Secure Connection</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'ShoplazzaTopNav',
  props: {
    storeName: {
      type: String,
      default: '',
    },
    platformLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    appName () {
      return process.env.VUE_APP_NAME || 'Pagsmile'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.top-nav {
  position: sticky;
  top: 0;
  z-index: 40;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(243, 244, 246, 0.8);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.top-nav-inner {
  max-width: 1024px;
  margin: 0 auto;
  padding: 0 24px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.nav-logo {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, $green, $green-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 800;
  font-size: 14px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.nav-name {
  font-size: 15px;
  font-weight: 700;
  color: $ink;
  letter-spacing: -0.01em;
  flex-shrink: 0;
}

.nav-separator {
  color: #e5e7eb;
  flex-shrink: 0;
}

.nav-context {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: $ink-3;
  min-width: 0;
}

.nav-context-strong {
  font-weight: 600;
  color: $ink-2;
  flex-shrink: 0;
}

.nav-store {
  font-weight: 600;
  color: $ink-2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 240px;
}

.nav-secure {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid $border-light;
  background: #f9fafb;
  font-size: 12px;
  color: $ink-4;
  flex-shrink: 0;

  svg {
    color: $green;
  }
}

@media (max-width: 768px) {
  .nav-store {
    max-width: 120px;
  }

  .nav-secure {
    display: none;
  }
}
</style>
